import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=38742102&scoped=true&"
import script from "./ServicesList.vue?vue&type=script&lang=js&"
export * from "./ServicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38742102",
  null
  
)

export default component.exports